import { useInView } from '@cian/valuation-utils-component';
import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessageLayout.css';
import { EMessageType } from '../../types/messageType';
import { TOutcomingStatus } from '../../types/messages';
import { noop } from '../../utils/noop';

interface IChatMessageLayoutProps {
  messageType: EMessageType;
  messageStatus?: TOutcomingStatus;
  onShow?(): void;
}

export const ChatMessageLayout: React.FC<React.PropsWithChildren<IChatMessageLayoutProps>> = ({
  children,
  messageType,
  messageStatus,
  onShow = noop,
}) => {
  const trackedRef = React.useRef(false);

  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  React.useEffect(() => {
    /** Трекаем показ только успешно отправленных и входящий сообщений */
    if (!inView || trackedRef.current || messageStatus === 'pending' || messageStatus === 'failed') {
      return;
    }

    trackedRef.current = true;

    onShow();
  }, [inView, onShow, messageStatus]);

  return (
    <div
      ref={ref}
      className={clsx(styles['message__layout'], styles[`message__layout_type_${messageType}`])}
      data-name="ChatMessageLayout"
    >
      {children}
    </div>
  );
};
